export const responseDetailsFormLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 20 },
};
